import React, { Component } from 'react';
import ItemWisePick from './Commons/ItemWisePick.js';
import JobsReassignment from './Commons/JobsReassignment.js';
import DateSelector from './../../../commons/DateSelector.js';
import JobsOperationsApiHandler from './../JobsOperationsApiHandler.js';
import CONF from '../../../config/config.js';

const datefor = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
});

var processPhases = [
    { name: 'Bulk Items', enum: 'FULFILMENT_BULK_PUT' },
    { name: 'Crate Items', enum: 'FULFILMENT_CRATING' },
];

export default class PickJobs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDate: null,
            customerGroup: [],
            equipmentType: [],
            productTypes: [],
            spaceTypes: [],
            options: [],
        };
        this.dateSelected = this.dateSelected.bind(this);
        this.fetchConfig = this.fetchConfig.bind(this);
    }

    componentWillMount() {
        this.fetchConfig();
    }

    fetchSpaceConfig = (facilityId) => {
        let req = {
            facilityId,
            spaceTypes: ['FLOOR', 'MEZZANINE_FLOOR'],
            isLeaf: false,
            spaceStatus: 'ACTIVE',
        };
        JobsOperationsApiHandler.getSpaceTypeConfig(req)
            .then((data) => {
                this.setState({ spaceTypes: data });
            })
            .catch((error) => {})
            .finally(() => {});
    };

    fatchNormalConfig = () => {
        var selectedFacility = JSON.parse(
            localStorage.getItem('selectedFacility')
        );
        JobsOperationsApiHandler.getPickJobsConfig()
            .then((data) => {
                this.setState({
                    customerGroup: data.customerTypes,
                    equipmentType: data.equipmentTypes,
                    productTypes: data.productTypes,
                });
                // if (selectedFacility.facilityId === 'FACIL-1441685588') {
                // 	this.setState({ equipmentType: ['NON_MHE'] });
                // }
            })
            .catch((error) => {})
            .finally(() => {});
    };

    fetchConfig() {
        var selectedFacility = JSON.parse(
            localStorage.getItem('selectedFacility')
        );
        if (CONF.facilitiesRequiringSpaceConfig.includes(selectedFacility.facilityId)) {
            this.fetchSpaceConfig(selectedFacility.facilityId);
        }
        this.fatchNormalConfig();
    }

    dates() {
        var selectedFacility = JSON.parse(
            localStorage.getItem('selectedFacility')
        );
        var dates = [];
		if(!selectedFacility) return [];

        var todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);
        var dateMillis = Date.parse(todayDate);

		const daysToAdd = CONF.specialDateFacilitiesD4.includes(selectedFacility.facilityName) ? 4 :
                      CONF.specialDateFacilitiesD3.includes(selectedFacility.facilityName) ? 3 :
                      CONF.specialDateFacilitiesD2.includes(selectedFacility.facilityName) ? 2 : 1;

		for (var i = 0; i <= daysToAdd; i++) {

			dates.push({
				deliveryDate: datefor.format(dateMillis),
				epochTime: dateMillis,
			});

			dateMillis += 86400000; // Add one day in milliseconds
		}
        return dates;
    }

    dateSelected(date) {
        this.setState({ selectedDate: date });
    }

    getFilteredCustomerGroup(processPhase) {
        const selectedFacility = JSON.parse(
            localStorage.getItem('selectedFacility')
        );
        const { customerGroup } = this.state;

        // For Bulk Items, filter out PRIORITY if not Sutluj/Gomati FC
        if (
            processPhase === 'FULFILMENT_BULK_PUT' &&
            selectedFacility &&
            selectedFacility.facilityName !== 'Sutlej/Gomati'
        ) {
            return customerGroup.filter((group) => group !== 'PRIORITY');
        }

        return customerGroup;
    }

    render() {
        const {
            selectedDate,
            customerGroup,
            equipmentType,
            productTypes,
            spaceTypes,
        } = this.state;
        return (
            <div>
                <div className='putaway-header'>
                    <div className='row'>
                        <div className='col-xs-12 col-sm-12 col-md-12 no-padding-xs'>
                            <div style={{ textAlign: 'right' }}>
                                <DateSelector
                                    dates={this.dates()}
                                    selected={selectedDate}
                                    classes={'pull-right'}
                                    dateSelected={this.dateSelected}
                                />
                            </div>
                        </div>
                    </div>
                    {!this.state.selectedDate ? (
                        <div
                            style={{
                                position: 'absolute',
                                right: '30px',
                                top: '64px',
                                width: '200px',
                            }}
                        >
                            <div className='action-message'>
                                Select a date for starting the pick job slot
                                generation
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className='pickjobs-wrapper'>
                    <JobsReassignment
                        processPhases={processPhases}
                        selectedDate={selectedDate}
                        spaceTypes={spaceTypes}
                        customerGroup={customerGroup}
                        equipmentType={equipmentType}
                    />
                    <ItemWisePick
                        itemType={'Bulk Items'}
                        processPhase={'FULFILMENT_BULK_PUT'}
                        selectedDate={selectedDate}
                        customerGroup={this.getFilteredCustomerGroup('FULFILMENT_BULK_PUT')}
                        equipmentType={equipmentType}
                        spaceTypes={spaceTypes}
                    />
                    <ItemWisePick
                        itemType={'Crate Items'}
                        processPhase={'FULFILMENT_CRATING'}
                        selectedDate={selectedDate}
                        customerGroup={customerGroup}
                        productTypes={productTypes}
                        equipmentType={equipmentType}
                        spaceTypes={spaceTypes}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/PickJobs.js